import {useEffect} from 'react';

import {getConditions} from '../services/Api';
import {useTermsStore} from '../store/slices/termsStore';

export const useGetConditions = () => {
  const commercialConditions = useTermsStore(
    (state) => state.commercialConditions
  );
  const commercialConditionsReceived = useTermsStore(
    (state) => state.commercialConditionsReceived
  );

  useEffect(() => {
    if (!commercialConditions || commercialConditions.length === 0) {
      getConditions().then((response) => {
        commercialConditionsReceived(response.data);
      });
    }
  }, [commercialConditions, commercialConditionsReceived]);
};
